export const firebaseConfig = {
  apiKey: 'AIzaSyBDDboZPPTFaNCnnjeoGO7U-70-ClTJeOk',
  authDomain: 'classic-driver-dev.firebaseapp.com',
  databaseURL: 'https://classic-driver-dev.firebaseio.com',
  projectId: 'classic-driver-dev',
  storageBucket: 'classic-driver-dev.appspot.com',
  messagingSenderId: '799746503686',
  appId: '1:799746503686:web:3cec5d1b3fe4daec'
};
